import {baseURL} from '@/config/index'
import { deflate } from 'zlib';
/**
 * 存放所有的接口地址
 */

const defaultBaseAction =  "pc/"
const commonAction = "common/"
const uploadEditor = commonAction
const uploadAction = commonAction+"file/"
const downAction = commonAction+"download/"
const areaAction = commonAction+"area/"
const dictAction = commonAction+"dict/"
const studentAction = "student/"
export default {
    webUrl:window.location.href,
    //轮播图
    ads:{
        list: baseURL+defaultBaseAction+'website_ads_list'
    },
    //首页配置
    indexConfig:{
        list:baseURL+defaultBaseAction+'featured_first_list'
    },
   //导航 
   channel:{
       list: baseURL+defaultBaseAction+'website_channel_list',
       childList:baseURL+defaultBaseAction+'website_channel_child_list',
       url:baseURL+defaultBaseAction+'website_channel',
   },
   //新闻
   document:{
       list: baseURL+defaultBaseAction+'news_list',
       url: baseURL+defaultBaseAction+'news', 
       cate:baseURL+defaultBaseAction+'news_category_simple_list',
       cateInfo:baseURL+defaultBaseAction+'news_category'
   },
   //网站配置
   webconfigInfo:baseURL+defaultBaseAction+'website_info',
   //项目
   project:{
        list: baseURL+defaultBaseAction+'project_list',
        url: baseURL+defaultBaseAction+'project',
        cate:baseURL+defaultBaseAction+'project_category_list',
        info:baseURL+defaultBaseAction+'project_category',
        progress:{
            list: baseURL+defaultBaseAction+'project_progress_list',
            url: baseURL+defaultBaseAction+'project_progress',
        },
        report:{
            list: baseURL+defaultBaseAction+'project_report_list',
            url: baseURL+defaultBaseAction+'project_report',
        },
        //受助对象
        recipient:{
            list:baseURL+defaultBaseAction+'project_recipient_list',
        }
    },
    //捐赠列表
    donation:{
        list: baseURL+defaultBaseAction+'donation_info_list',
        index:baseURL+defaultBaseAction+'index'
    },
    //文件下载
    fileDown:{
        url:baseURL+downAction
    },    
    // 友情链接
    friendlyLink:{
        list:baseURL+defaultBaseAction+"friendly_links_simple_list"
    },
    //话题列表
    topic:{
        //话题总览
        list:baseURL+defaultBaseAction+"bbs_article_list",
        //新增话题
        add:baseURL+defaultBaseAction+"bbs_article",
        //话题详情
        info:baseURL+defaultBaseAction+"bbs_article",
        //发帖记录
        post:baseURL+defaultBaseAction+"user_bbs_article_list",
        //回帖记录
        reply:baseURL+defaultBaseAction+"user_bbs_comment_list",
    },
    //文件上传
    updata:{
        upload:baseURL+commonAction+"pub_file",//话题封面上传
        uploadEditor:baseURL+uploadEditor+"editor",//富文本图片上传
    },
    //用户登录
    login:{
        user:baseURL+defaultBaseAction+"user_login",
        detection_name:baseURL+defaultBaseAction+"check_mobile",
    },
    //获取验证码
    code:{
        send_code:baseURL+commonAction+"send_code"
    },
    //发布评论
    comment:{
        send_comment:baseURL+defaultBaseAction+"bbs_comment"
    },
    //话题点赞
    favorite:{
        //点赞
        add_favorite:baseURL+defaultBaseAction+"bbs_article_favorite",
    }
}



// WEBPACK FOOTER //
// ./src/config/url.js